// Kleine DOM-Hilfen. Text immer über textContent, nie als HTML (DQ-SEC-030).
/** Entfernt Zeichen, mit denen ein Wert aus einer CSS-Deklaration ausbrechen könnte. */
export function cssSafe(v) {
    return String(v ?? '').replace(/[;{}<>"'\\\n\r]/g, '');
}
export function cssUrl(u) {
    return `url("${String(u).replace(/["\\\n\r]/g, (c) => encodeURIComponent(c))}")`;
}
export function h(doc, tag, o = {}, children = []) {
    const el = doc.createElement(tag);
    if (o.class)
        el.className = o.class;
    if (o.style)
        el.setAttribute('style', o.style);
    if (o.text !== undefined)
        el.textContent = o.text;
    for (const [k, v] of Object.entries(o.attrs ?? {})) {
        if (v === undefined || v === false)
            continue;
        el.setAttribute(k, v === true ? '' : v);
    }
    for (const c of children)
        el.appendChild(c);
    return el;
}
export function clear(el) {
    while (el.firstChild)
        el.removeChild(el.firstChild);
}
export function placeholder(doc, box, ...lines) {
    clear(box);
    const div = h(doc, 'div', { class: 'wl-placeholder' });
    lines.forEach((l, i) => {
        if (i)
            div.appendChild(doc.createElement('br'));
        div.appendChild(i ? h(doc, 'small', { text: l }) : doc.createTextNode(l));
    });
    box.appendChild(div);
}
//# sourceMappingURL=dom.js.map